import { lazy, Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import { Center, Spinner, VStack, Text, Button } from "@chakra-ui/react";
import { RootLayout } from "../components/layouts/RootLayout";
import { routes as browseRoutes } from "./browse/routes";
import { routes as downloadsPaths } from "./downloads/routes";
import { routes as inboxRoutes } from "./inbox/routes";
import { routes as newsPaths } from "./news/routes";
import { routes as shelfPaths } from "./shelf/routes";
// import { routes as adminPaths } from "./admin/routes";
import { routes as readerPaths } from "./reader/routes";
import { routes as goldPaths } from "./gold/routes";
import { routes as giftPaths } from "./gift/routes";
import RootScreen from "./root/RootScreen";
import { routes as legalPaths } from "./legal/routes";
import { routes as newsRoutes } from "./news/routes";
import { routes as globalChatRoutes } from "./globalChat/routes";
import { routes as redemptionSuccessRoutes } from "./redemptionSuccess/routes";
import { routes as valkyraeRoutes } from "./valkyrae/routes";
import { routes as trendsRoutes } from "./trends/routes";
import { routes as expandedContentRoutes } from "./expandedContent/routes";
import { routes as holidayBundleRoutes } from "./holidayBundle/routes";
import { routes as ultimateXmenBundleRoutes } from "./ultimateXmenBundle/routes";
import { routes as settingsRoutes } from "./settings/routes";

// Lazy-loaded admin panel — keeps admin code out of the public bundle
const AdminNextApp = lazy(() => import("./adminNext/AdminNextApp"));

function AdminLoadingFallback() {
  return (
    <Center h="100vh" bg="#0E0F11">
      <Spinner size="xl" color="orange.400" />
    </Center>
  );
}

function AdminChunkError() {
  return (
    <Center h="100vh" bg="#0E0F11">
      <VStack spacing={4}>
        <Text color="red.400" fontSize="xl">Failed to load admin panel</Text>
        <Button colorScheme="orange" size="sm" onClick={() => window.location.reload()}>Retry</Button>
      </VStack>
    </Center>
  );
}

export const applicationRoutes = createRoutesFromElements(
  <Route path="/" element={<RootLayout />}>
    {browseRoutes}
    {downloadsPaths}
    {shelfPaths}
    <Route path="library" element={<Navigate to="/my-shelf/library" replace />} />
    {newsPaths}
    {inboxRoutes}
    {readerPaths}
    {goldPaths}
    {giftPaths}
    {legalPaths}
    {newsRoutes}
    {globalChatRoutes}
    {redemptionSuccessRoutes}
    {valkyraeRoutes}
    {trendsRoutes}
    {expandedContentRoutes}
    <Route
      path="admin-next/*"
      element={
        <Suspense fallback={<AdminLoadingFallback />}>
          <AdminNextApp />
        </Suspense>
      }
      errorElement={<AdminChunkError />}
    />
    {holidayBundleRoutes}
    {ultimateXmenBundleRoutes}
    {settingsRoutes}
    {/*{window.gc.global.is_superadmin && adminPaths}*/}
    <Route path="/deals" Component={RootScreen} />
    <Route path="/new" Component={RootScreen} />
    <Route path="/channel?/:channel?/:slug?" Component={RootScreen} />
  </Route>,
);

export const router = createBrowserRouter(applicationRoutes);
